import { useState, useEffect } from "react";
import Loader from "./Loader.jsx";

const Meetings = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [meetings, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/data/founder.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        // console.log(data);

        setBooks(data.meetings);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <Loader />;
  if (error) return <div className="error-message">Error: {error}</div>;

  const openImage = (img) => {
    setSelectedImage(img);
  };

  const closeImage = () => {
    setSelectedImage(null);
  };
  return (
    <div className="gallery-container">
      <h1>சந்திப்புகள்</h1>
      <div className="image-grid1">
        {meetings.map((img, index) => (
          <div
            key={index}
            className="image-item"
            onClick={() => openImage(img)}
          >
            <img src={img} alt={`Gallery item ${index + 1}`} />
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="fullscreen-overlay" onClick={closeImage}>
          <div className="fullscreen-image-container">
            <img src={selectedImage} alt="Full screen" />
            <button className="close-button" onClick={closeImage}>
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Meetings;

// import { useState, useEffect } from "react";

// const Meetings = () => {
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [meetings, setMeetings] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchMeetings = async () => {
//       try {
//         const response = await fetch("http://localhost:5000/api/meetings");
//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }
//         const data = await response.json();
//         setMeetings(data);
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchMeetings();
//   }, []);

//   const openImage = (imgUrl) => {
//     setSelectedImage(imgUrl);
//   };

//   const closeImage = () => {
//     setSelectedImage(null);
//   };

//   if (loading) return <div className="loading-message">Loading...</div>;
//   if (error) return <div className="error-message">Error: {error}</div>;

//   return (
//     <div className="gallery-container">
//       <h1>சந்திப்புகள்</h1>
//       <div className="image-grid">
//         {meetings.map((meeting, index) => (
//           <div
//             key={index}
//             className="image-item"
//             onClick={() => openImage(meeting.imageUrl)}
//           >
//             <img
//               src={meeting.imageUrl}
//               alt={`Meeting ${index + 1}`}
//               loading="lazy"
//             />
//             {meeting.title && <p>{meeting.title}</p>}
//           </div>
//         ))}
//       </div>

//       {selectedImage && (
//         <div className="fullscreen-overlay" onClick={closeImage}>
//           <div className="fullscreen-image-container">
//             <img src={selectedImage} alt="Full screen" />
//             <button className="close-button" onClick={closeImage}>
//               ×
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Meetings;
